import React, { useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";

const ImageViewer = ({
    isOpen,
    images,
    currentIndex,
    onClose,
    onPrevious,
    onNext
}) => {
    const touchStart = useRef(null);
    const touchEnd = useRef(null);

    const handleTouchStart = (e) => {
        touchStart.current = e.touches[0].clientX;
    };

    const handleTouchMove = (e) => {
        touchEnd.current = e.touches[0].clientX;
    };

    const handleTouchEnd = () => {
        const distance = touchStart.current - touchEnd.current;
        if (distance > 50) {
            onNext();
        } else if (distance < -50) {
            onPrevious();
        }
    };

    if (!isOpen) return null;

    return (
        <div className={`image-viewer ${isOpen ? "show" : ""}`} onClick={onClose}>
            <FontAwesomeIcon
                icon={faXmark}
                onClick={onClose}
                className="custom-close-icon"
            />

            <button
                className="prev-btn"
                onClick={(e) => {
                    e.stopPropagation();
                    onPrevious();
                }}
            >
                ‹
            </button>

            <div
                className="viewer-img-wrapper"
                onClick={(e) => e.stopPropagation()}
                onTouchStart={handleTouchStart}
                onTouchMove={handleTouchMove}
                onTouchEnd={handleTouchEnd}
            >
                <img
                    src={images[currentIndex]}
                    alt="Zoomed"
                    className="viewer-img fade-in"
                />
            </div>

            <button
                className="next-btn"
                onClick={(e) => {
                    e.stopPropagation();
                    onNext();
                }}
            >
                ›
            </button>
        </div>
    );
};

export default ImageViewer;